import { gql } from '@apollo/client';
import CompanyBasicSettingsFields from "../../../fragments/CompanyAdminContext/BasicSettings";

const GET_COMPANY_BASIC_SETTINGS = gql`
  query GetCompanyBasicSettings($companyId: Int!) {
    companyAdminContext {
      companySettings {
        getCompanyBasicSettings(companyId: $companyId) {
          ...CompanyBasicSettingsFields
        }
      }
    }
  }
  ${CompanyBasicSettingsFields}
`;

export default GET_COMPANY_BASIC_SETTINGS;
